import { Injectable } from '@angular/core';
import { API } from '../configuration/end-points';
import { NetworkService } from '../configuration/network.service';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class EvoGlobalService {
  constructor(
    private networkService: NetworkService,
    private http: HttpClient) { }

  ttProcessedASOAPPlanStatus = 7;
  ttSettledASOAPPlanStatus = 8;

  getMenuItemList(model: any) {

    return this.networkService.addModel(model, API.MENUITEMS.MENUITEM);
  }
  //getCallWithBody(apiEndPoint: string, params?: HttpParams, body?:string)


  getMenuItemOnRefresh() {

    return this.networkService.getMenuApi({ screenList: true }, API.MENUITEMS.MENUITEM);
  }

  getConfigurations(filename: string) {
    try {
      return this.http.get<any>("/assets/json/config/" + filename + ".json").toPromise();
    } catch (ex) {
      return null;
    }
  }

  getFile(filpath: string) {
    try {
      return this.http.get<any>(filpath);
    } catch (ex) {
      return null;
    }
  }

  logout(model: any) {
    return this.networkService.updateModel(model, API.LOGOUT.LOGOUT)
  }

}

